import React, { useEffect, useRef } from 'react';
import './Loading.css';
import logo from '../RapidMind 2025.png';
import voxelSound from '../voxel.mp3';

const Loading = () => {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = new Audio(voxelSound);
    audio.volume = 0.5;
    audio.muted = false;
    audioRef.current = audio;

    let interval;

    const startAudio = () => {
      if (audioRef.current) {
        audioRef.current.play().then(() => {
          // If play succeeds, start the interval for rhythm
          interval = setInterval(() => {
            if (audioRef.current) {
              audioRef.current.currentTime = 0;
              audioRef.current.play().catch((e) => console.log('Audio play error:', e));
            }
          }, 1500);
        }).catch((e) => {
          console.log('Audio play prevented:', e);
        });
      }
    };

    // Try to play immediately
    startAudio();

    // If autoplay is blocked, wait for user interaction
    const handleInteraction = () => {
      if (!interval) {
        startAudio();
      }
      // Remove listeners after first interaction
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('keydown', handleInteraction);
    };

    document.addEventListener('click', handleInteraction);
    document.addEventListener('keydown', handleInteraction);

    return () => {
      if (interval) clearInterval(interval);
      if (audioRef.current) audioRef.current.pause();
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('keydown', handleInteraction);
    };
  }, []);

  return (
    <div className="loading-container">
      <img src={logo} alt="RapidMind Logo" className="loading-logo" />
    </div>
  );
};

export default Loading;
